import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {CreditBundle, UserBalanceDetail} from '../interfaces/credit.interface';

@Injectable({providedIn: 'root'})
export class CreditResource {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getBalance(): Observable<UserBalanceDetail> {
    return this.http.get<UserBalanceDetail>(`${this.baseUrl}/credits/balance`);
  }

  getBundles(): Observable<CreditBundle[]> {
    return this.http.get<CreditBundle[]>(`${this.baseUrl}/credits/bundles`);
  }

  purchaseBundle(bundleId: string): Observable<UserBalanceDetail> {
    return this.http.post<UserBalanceDetail>(`${this.baseUrl}/credits/purchase`, {bundleId});
  }
}
